import {
  MEASURE_UNITS,
  MeasureUnit,
  findMeasureUnit,
  measureUnitLabel,
} from "../../models/measure-unit";
import SelectBootstrap from "../react-select-bootstrap/SelectBootstrap";

type MeasureUnitSelectProps = {
  value?: number | null;
  onChange: (_: number) => void;
};

/**
 * Picks a unit of measure by its name, and hands back the SIFEN code.
 *
 * Searchable because the table is long and people look for "kilo" or "hora",
 * not for 83 or 100.
 */
const MeasureUnitSelect: React.FC<MeasureUnitSelectProps> = ({
  value,
  onChange,
}) => {
  const selected =
    value === undefined || value === null ? null : findMeasureUnit(value);

  return (
    <SelectBootstrap
      options={MEASURE_UNITS}
      value={selected}
      isSearchable={true}
      placeholder="Unidad de medida"
      getOptionLabel={(option) => measureUnitLabel(option as MeasureUnit)}
      getOptionValue={(option) => `${(option as MeasureUnit).code}`}
      onChange={(option) => {
        if (option !== null) {
          onChange((option as MeasureUnit).code);
        }
      }}
      noOptionsMessage={() => "No hay unidades que coincidan"}
    />
  );
};

export default MeasureUnitSelect;
